import { combineReducers } from "@reduxjs/toolkit";
import viewEnrollmentToolsDocument from "./view-enrollment-tools-document";

const viewEnrollmentToolsDocumentReducer = combineReducers({
  viewEnrollmentToolsDocument,
});

export default viewEnrollmentToolsDocumentReducer;
